import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { SuperloginComponent } from "./superlogin/superlogin.component";
import { ForgotpasswordComponent } from "./forgotpassword/forgotpassword.component";
import { ResetpasswordComponent } from "./resetpassword/resetpassword.component";
export const routes: Routes = [
  { path: "", component: SuperloginComponent },
  { path: "forgotpassword", component: ForgotpasswordComponent },
  { path: "resetpassword", component: ResetpasswordComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {}
